import styled from "styled-components";
import { SectionWrapper } from "shared/Styles/Wrappers";

export const Container = styled.div`
  padding: 124px 0;
  background-color: ${({ color }) => (color ? color : "#fff")};
  color: ${({ color }) => (color ? "#fff" : "#000")};
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    padding: 64px 0;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 36px 0;
  }
`;

export const Wrapper = styled(SectionWrapper)`
  display: flex;
  flex-direction: ${({ reverse }) => (reverse ? "row-reverse" : "row")};
  text-align: ${({ reverse }) => (reverse ? "right" : "left")};
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone_big}) {
    text-align: center;
    flex-direction: column;
  }
`;

export const Column = styled.div`
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone_big}) {
    width: 100%;
  }
`;

export const Video = styled.video`
  max-width: 300px;
  width: 100%;
  height: auto;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    max-width: 200px;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    max-width: 150px;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone_big}) {
    margin-bottom: 48px;
  }
`;

export const TextBox = styled.div`
  margin-bottom: 56px;
  max-width: 540px;
  width: 100%;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    max-width: 440px;
  }
`;

export const Title = styled.h3`
  font-size: 4rem;
  line-height: 1;
  font-weight: 800;
  margin-bottom: 24px;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    font-size: 3rem;
  }
  @media screen and (max-width: ${({ theme }) =>
      theme.breakpoints.tablet_big}) {
    font-size: 2.4rem;
  }
`;

export const Text = styled.p`
  display: inline;
  font-size: 1.6rem;
  font-weight: 300;
  line-height: 1.5;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    font-size: 1.4rem;
  }

  @media screen and (max-width: ${({ theme }) =>
      theme.breakpoints.tablet_big}) {
    font-size: 1.2rem;
  }
`;
